module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(!_vm.error) ? _c('div', {
    staticClass: "row full-height"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('creative-step')], 1), (_vm.canViewProgress) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('workflow-progress', {
    attrs: {
      "title": _vm.$t("pos.creative.work-process"),
      "steps": _vm.steps
    }
  })], 1) : _vm._e()]) : ([404, 403].includes(_vm.error.code)) ? _c('not-found') : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaf43960"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/creative/Creative.vue
// module id = 2099
// module chunks = 1